import { render, staticRenderFns } from "./DisruptionsTable.vue?vue&type=template&id=f64f03c2&"
import script from "./DisruptionsTable.vue?vue&type=script&lang=js&"
export * from "./DisruptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports